import React from 'react';
import { Text } from '../../../Text';
export const Label = _ref => {
  let {
    id,
    children
  } = _ref;
  if (!children) return null;
  return React.createElement(Text.BodyMedium, {
    tag: "label",
    htmlFor: id,
    marginBottom: "--spacing-1",
    weight: "semibold"
  }, children);
};
Label.displayName = 'Label';